
import { SVGProps } from 'react';

const ContactUsEmail = ({
    width = 24,
    height = 24,
    fill = '#2A2A2A',
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M-0.000488281 6C-0.000488281 4.34315 1.34266 3 2.99951 3H20.9995C22.6564 3 23.9995 4.34315 23.9995 6V18C23.9995 19.6569 22.6564 21 20.9995 21H2.99951C1.34266 21 -0.000488281 19.6569 -0.000488281 18V6ZM2.24932 6.75C2.24932 5.92157 2.92089 5.25 3.74932 5.25H20.2493C21.0777 5.25 21.7493 5.92157 21.7493 6.75V17.25C21.7493 18.0784 21.0777 18.75 20.2493 18.75H3.74932C2.92089 18.75 2.24932 18.0784 2.24932 17.25V6.75ZM3.49312 7.01119C3.76548 6.45275 4.43899 6.22084 4.99743 6.49321L11.962 9.89005L18.9263 6.49329C19.4848 6.22093 20.1583 6.45283 20.4307 7.01127C20.703 7.56971 20.4711 8.24321 19.9127 8.51558L12.4976 12.1321C12.3246 12.2165 12.1405 12.2525 11.9608 12.2454C11.7817 12.2521 11.5984 12.2161 11.4261 12.1321L4.01109 8.5155C3.45265 8.24313 3.22075 7.56963 3.49312 7.01119Z" fill={fill} />
    </svg>
);

export default ContactUsEmail;
